module.exports = __webpack_public_path__ + "media/images/icons/arrow-down-423d535a7c00e4c46d36118647e4e5d2.svg";